import React, { useState, useEffect, useContext } from "react";
import { fetchWithDefaults } from '../../../config/fetchDefault';
import Icon from "../../../assets/icons/icon";
import { useDispatch } from "react-redux";
import { setTextNumbers } from "../../../features/agentSlice";
import { useSelector } from "react-redux";
import { AgentContext } from "../../../context/AgentContext";

function AddNumberToService({serviceInfo , type,service,agent, setUpdate, setNumberChoice, fetchServices, setLoading, brandInfo}) {
    const [numbers, setNumbers] = useState(false);
    const [error, setError] = useState(false);

    const dispatch = useDispatch()

    const fetchNumbers= async(fields, brand, type)=>{
        setLoading(true)
        try {
            const response = await fetchWithDefaults(`/trustHub/getNumbers?agent=${agent}`);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            setNumbers(jsonData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        setLoading(false)
    }
    const addToService= async(service, number)=>{
        setError(false)
        try {
            const requestOptions = {
                method: 'PATCH',
                body: JSON.stringify({
                    agent: agent,
                    service:service,
                    number:number
                })
            };

            const response = await fetchWithDefaults(`/trustHub/addToService`, requestOptions);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const jsonData = await response.json();
            if(jsonData.status){
                fetchServices();
                setNumberChoice(false);

                // update numbers in data in agent slice
                const response = await fetchWithDefaults(`/twilioToken?agent=${agent}`)

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const [twilioData] = await response.json()
                dispatch(setTextNumbers(twilioData.textingNumbers))
            }
            else{
                setError(jsonData.message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(() => {
        fetchNumbers();
    },[ ])

    const {isB2B} = useContext(AgentContext)
    const colorData = useSelector(state => state.colorData)
    const isSole = type?.toLowerCase() === "sole";
    const isSoleProprietor = brandInfo[0]?.brandType === "SOLE_PROPRIETOR";
    const hasAssociatedNumber = serviceInfo && serviceInfo.some(item=> item.phoneNumbers.length >= 1)
    // const isAssociatedWithOtherServices = numbers && numbers?.some((number) => number.isAssociatedWithOtherServices);
    const isDisabled = (isSole || isSoleProprietor)  && hasAssociatedNumber;

    return (
        <div className="quilityPopupFormWrapper">
            <div className="quilityPopupFormContent">
                <div className="quilityCloseWindow" onClick={()=>setNumberChoice(false)}><span className="fontello" style={{marginTop: '-7px'}}><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span></div>
                <div className="title" style={{padding:'20px', marginTop:'unset'}}>Choose a number to enable text messaging on! </div>
                {type==='STANDARD' ? (
                    <div className='subTitle' style={{fontWeight:'700', marginBottom:"10px"}}>You can add as many numbers as you'd like</div>
                ) : (
                    <div className='subTitle' style={{fontWeight:'700', marginBottom:"10px"}}>You can add only add one number to your service</div>
                )}
                {error && (
                    <div className="errorMessage" style={{textAlign:'center'}}>{error}</div>
                )}
                {numbers && numbers.map((number, index) => {
                    return (
                    <div key={`add_number_${index}`} className={`brandSelection ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} style={{minWidth:'200px', textAlign:'center', backgroundColor: isDisabled ? '#aaa' : '',
                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                opacity: isDisabled ? 0.6 : 1, }} onClick={()=> {if (!isDisabled) addToService(service,number.id) } }>{number.name}</div> )
                })}

            </div>
        </div>
    );
}
export default AddNumberToService;

